<h1>Albion Online User Crafts History</h1>
@if (!(authService.user$ | async)) {
  <div>
    You need to <button mat-flat-button color="accent" (click)="authService.googleSignIn()"><mat-icon>login</mat-icon>LOGIN</button> to use this tool.
  </div>
}

@if (authService.user$ | async) {
  <div>
    <app-text-divider style="width: 100%">CRAFT HISTORY</app-text-divider>
    @if (!sortedData.length) {
      <div style="margin-bottom: 10px">
        <mat-card style="width: 100%">
          <mat-card-content>You have no saved crafts yet.</mat-card-content>
          <mat-card-content>In the crafting page, after completing a craft, click "Save this craft!" to save it.</mat-card-content>
          <mat-card-content>If you save your crafts, you can see your crafting history here.</mat-card-content>
        </mat-card>
      </div>
    }
    @if (sortedData.length) {
      <div style="margin-bottom: 10px">
        <mat-card style="width: 100%">
          <mat-card-content
            >You've completed {{ userCraftsTotal.count | smallNumber }} crafts, investing {{ userCraftsTotal.totalCost | smallNumber }} and earning a total
            income of {{ userCraftsTotal.totalIncome | smallNumber }}.</mat-card-content
          >
          <mat-card-content>Your overall profit stands at {{ userCraftsTotal.totalProfit | smallNumber }}.</mat-card-content>
          <mat-card-content>Find detailed information on your most recent 50 crafts below.</mat-card-content>
        </mat-card>
      </div>

      <div class="table-container">
        <table mat-table [dataSource]="sortedData" matSort (matSortChange)="sortData($event)" class="mat-elevation-z8">
          <!-- Date Column -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-120">Date</th>
            <td mat-cell *matCellDef="let element" class="min-width-120">{{ element.date | date: 'MMM dd, yyyy hh:mm a' : 'UTC' }}</td>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="productUniqueName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Item</th>
            <td mat-cell *matCellDef="let element" class="min-width-160">{{ jsonReaderService.getItemFromIndex(element.productUniqueName)?.localizedName }}</td>
          </ng-container>
          <!-- Bought Column -->
          <ng-container matColumnDef="bought">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Bought in</th>
            <td mat-cell *matCellDef="let element" class="min-width-120">{{ element.craftingConfiguration.buyLocation.displayName }}</td>
          </ng-container>
          <!-- Sold Column -->
          <ng-container matColumnDef="sold">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Sold in</th>
            <td mat-cell *matCellDef="let element" class="min-width-120">{{ element.craftingConfiguration.sellLocation.displayName }}</td>
          </ng-container>
          <!-- Amount Column -->
          <ng-container matColumnDef="amountCrafted">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-80">Amount</th>
            <td mat-cell *matCellDef="let element" class="min-width-80">{{ element.amountCrafted | number: '1.0-0' }}</td>
          </ng-container>
          <!-- Investment Column -->
          <ng-container matColumnDef="investment">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-120">Investment</th>
            <td mat-cell *matCellDef="let element" class="min-width-120">$ {{ element.totalCost | number: '1.0-0' }}</td>
          </ng-container>
          <!-- Result Column -->
          <ng-container matColumnDef="result">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-120">Profit</th>
            <td mat-cell *matCellDef="let element" class="min-width-120">
              $ {{ element.result | number: '1.0-0' }} <br />
              ({{ element.resultPercentage | percent: '1.2-2' }})
            </td>
          </ng-container>
          <!-- Result/Focus Column -->
          <ng-container matColumnDef="resultPerFocus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-120">Profit/Focus</th>
            <td mat-cell *matCellDef="let element" class="min-width-120">
              {{ element.craftingConfiguration.usedFocus ? (element.resultPerFocus | number: '1.2-2') : '-' }}
            </td>
          </ng-container>
          <!-- Delete Column -->
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef class="min-width-80">Delete</th>
            <td mat-cell *matCellDef="let element" class="min-width-80">
              <button style="zoom: 0.75" color="warn" mat-mini-fab (click)="deleteCraft(element)" aria-label="Delete Craft">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    }
  </div>
}
